/**
 * @description 考试，问卷，作业提交时间设置 相关接口
 * @interface https://wiki.umu.work/pages/viewpage.action?pageId=27597211
 * @param session_id
 */
import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { PARTICIPATE_STATUS } from '@umu/umu-types';

interface IInput {
    session_id: number;
}

export interface IOutput {
    accept_submission_time: number;
    refuse_submission_time: number;
    participate_status: PARTICIPATE_STATUS;
}

export const getParticipateStatus = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.GET_PARTICIPATE_STATUS, data, { silent: true }).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};

export const getParticipateStatusSync = fetchDataSync(getParticipateStatus);
